// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { mergeWithCss } from "@guestsupply/XDL/Utilities";
import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { css } from "styled-components";

dateRangeStyles.datePickersWrapper = {
    ...myAccountFilterSectionStyles.datePickersWrapper,
};

dateRangeStyles.fromDate = {
    ...myAccountFilterSectionStyles.fromDate,
};
dateRangeStyles.toDate = {
    ...myAccountFilterSectionStyles.toDate,
};
